import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Feather } from 'lucide-react';
export function ProofSection() {
  return <section className="py-24 bg-cream relative" data-id="element-164">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-165">
        <FadeIn data-id="element-166">
          <Feather className="w-12 h-12 text-gold mx-auto mb-8" strokeWidth={1} data-id="element-167" />

          <h2 className="text-3xl md:text-4xl font-serif text-brown mb-8 leading-tight" data-id="element-168">
            Resultados que se sienten en el cuerpo
          </h2>

          <div className="bg-white p-8 md:p-12 rounded-3xl shadow-xl shadow-brown/5 border border-gold/10" data-id="element-169">
            <p className="text-xl md:text-2xl text-brown/80 leading-relaxed font-serif italic" data-id="element-170">
              "En los primeros 7 días de aplicar la Suavidad Estratégica,
              notarás que la tensión en tus hombros desaparece, tu sueño se
              vuelve profundo por primera vez en años y, mágicamente, las
              personas a tu alrededor comenzarán a ofrecerte la ayuda que antes
              tenías que mendigar o exigir."
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}